export default "__VITE_ASSET__3ac66c31__"